export default function PHP___halt_compiler() {
  return (
    <div>
      <h1>PHP___halt_compiler</h1>
    </div>
  );
}
